import { render, staticRenderFns } from "./SrSelectItem.vue?vue&type=template&id=619c62db"
import script from "./SrSelectItem.vue?vue&type=script&lang=js"
export * from "./SrSelectItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports